import Axios from "axios";
import qs from "qs";
// import app from '../main';
import BaseurlInstance from "./baseurl";
import { getUrlParam } from "../common/js/utils";

Axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
Axios.defaults.headers.get["Content-Type"] = "application/x-www-form-urlencoded";

// post请求
function post(url, params = {}, options = {}) {
  return Axios.post(url, qs.stringify(params), options);
}

// 参数形式的get请求
function get(url, params) {
  return new Promise((resolve, reject) => {
    Axios({
      method: 'get',
      url,
      params: params,
    }).then(res => {
      resolve(res.data.data);
    })
  })
}

// 单个以/分割的get请求,后台非得搞这么个玩意，无语了
function getNoParams(url, params) {
  return new Promise((resolve, reject) => {
    let urlsArr = Object.keys(params).map(item => params[item]).join('/');
    let getUrl = `${url}/${urlsArr}`;
    return Axios.get(getUrl).then(res => {
      resolve(res.data.data);
    })
  });
}


// 请求老项目接口
function ajaxDevOvopark(url, params, options = {}) {
  let obj = qs.stringify(params);
  if (options.headers && options.headers['Content-Type'] === 'application/json') {
      obj = params;
  }
  return new Promise((resolve, reject) => {
    Axios.post(url, obj, options).then(res => {
      if (res.status === 200 && (res.data.result === 'ok' || res.data.result === '成功')) {
        resolve(res.data.data);
      }
    }).catch(e => {
      reject(e);
    })
  })
}

/**
 * json格式的Post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const postJson = async (url, params) => {
  const res = await Axios.post(url, params, {
    headers: {
      "Content-Type": "application/json"
    }
  });
  return new Promise((resolve, reject) => {
    if (res.status === 200 && res.data.result === "ok") {
      resolve(res.data.data);
    } else {
      reject(res.data);
    }
  })
};


// // 封装CRM，post请求
// // function postCrm(url, params) {
// //   return Axios.post('/cloudCrm/api/crm/system/v1/getTicket').then(res => {
// //     console.log(res);
// //   })
// // }
// function postCrm(url, params) {
//   return getCrmTicket().then(tickRes => {
//     return new Promise((resolve, reject) => {
//       Axios.post(url, qs.stringify(params), { headers: { 'ticket': tickRes.ticket } }).then(res => {
//         if (res.status === 200 && (res.data.result === 'ok' || res.data.result === '成功')) {
//           resolve(res.data.data);
//         } else {
//           reject(res);
//         }
//       })
//     })
//   })
// }

/**
 * 设置ticket
 * @param {string} ticket token
 */
const setToken = ticket => {
  const langList = ["CN", "EN"];
  let lang = getUrlParam("lang").toUpperCase();
  if (!langList.includes(lang)) lang = "CN";
  lang === "CN" &&
    (Axios.defaults.headers.post.authenticator = `${ticket} BILLING 1.0 SIMPLIFIED_CHINESE GMT+8:00`) && (Axios.defaults.headers.get.authenticator = `${ticket} BILLING 1.0 SIMPLIFIED_CHINESE GMT+8:00`); // 简体中文
  lang === "EN" &&
    (Axios.defaults.headers.post.authenticator = `${ticket} BILLING 1.0 ENGLISH GMT+8:00`) && (Axios.defaults.headers.get.authenticator = `${ticket} BILLING 1.0 ENGLISH GMT+8:00`); // 英文
};

const setEnvironMent = () => {
  return new Promise((resolve, reject) => {
    BaseurlInstance.getUrl().then(url => {
      Axios.defaults.baseURL = url;
      resolve(url);
    })
  })
}

/**
 * 计费接口
 */

/**
 * 获取组织架构tree
 */
const getOrganizesTree = (params = {}) => ajaxDevOvopark("/service/getOrganizesTree.action", params, { baseURL: '' });
/**
 * 获取权限列表
 */
const getPrivileges = (params = {}) => ajaxDevOvopark("/service/getPrivileges.action", params, { baseURL: '' });
/**
 * 获取所有企业
 */
const getAllEnterprises = (params = {}) => ajaxDevOvopark("/service/getUserGroups.action", params, { baseURL: '' });
/**
 * 获取个人信息
 */
const getMyInfo = (params = {}) => ajaxDevOvopark("/service/getMyInfo.action", params, { baseURL: '' });

/**
 * 获取账户详情
 */
const getAccount = (params = {}) => postJson("/ovopark-console/account", params);
/**
 * 获取模块列表
 */
const getModuleList = (params = {}) =>
  get("/ovopark-console/module/list", params);
/**
 * 获取模块下的产品列表
 */
const getModuleProductList = (params = {}) =>
  getNoParams("/ovopark-console/module/product", params);
/**
 * 申请开通、预开通模块产品
 */
const openModuleOrder = (params = {}) =>
  postJson("/ovopark-console/module/open", params);
/**
 * 开通申请列表
 */
const ordersModuleOrder = (params = {}) =>
  get("/ovopark-console/module/orders", params);
/**
 * 模块订单详情
 */
const getModuleProductDetail = (params = {}) => getNoParams("/ovopark-console/module/orderDetail", params);
/**
 * 查询订单对应开通的设备或门店
 */
const getStoreOrService = (params = {}) => get("/ovopark-console/module/orderOpens", params);
/**
 * 对公转账新增接口
 */
const payByPublic = (params = {}) => postJson("/ovopark-console/payRecords/add", params);
/**
 * 支付记录
 */
const getPayRecords = (params = {}) => get('/ovopark-console/payRecords', params);
/**
 * CRM项目，保存申请发票接口
 */
const saveInvoiceOfCrm = (params = {}) => ajaxDevOvopark('/cloudCrm/api/crm/bill/v1/saveBilling', params, { baseURL: '' });

/**
 * 审核通过缴费续费
 */
const renewOrder = (params = {}) => postJson("/ovopark-console/module/renew", params);
/**
 * 消息列表
 */
const getMessageList = (params = {}) => get('/ovopark-console/message', params);
/**
 * 标记消息列表
 */
const updateMessage = (params = {}) => postJson('/ovopark-console/message/update', params);
/**
 * 修改续费方式
 */
const updateRenewType = (params = {}) => postJson('/ovopark-console/openRecord/update', params);
/**
 * 充值消费记录
 */
const getBillList = (params = {}) => get('/ovopark-console/product-flow', params);
/**
 * 获取急需续费
 */
const getUrgentList = (params = {}) => get('/ovopark-console/openRecord/needRenews', params);
/**
 * 查询订单对应开通的设备或门店
 */
const getOrderOpens = (params = {}) => get('/ovopark-console/openRecord/orderOpens', params);
/**
 * 手动续费接口
 */
const usedRenew = (params = {}) => postJson('/ovopark-console/openRecord/usedRenew', params);
/**
 * 查询门店
 */
const getStore = (params = {}) => get('/ovopark-console/account/depts', params);
/**
 * 查询设备
 */
const getDevice = (params = {}) => get('/ovopark-console/account/devices', params);
/**
 * 门店或者设备使用开通模块
 */
const useProduct = (params = {}) => postJson('/ovopark-console/openRecord/useProduct', params);
/**
 * 微信支付接口
 */
const wxPay = (params = {}) => postJson('/ovopark-console/pay', params);
/**
 * 查询支付结果
 */
const payDetail = (params = {}) => getNoParams("/ovopark-console/payRecords/detail", params);
/**
 * 查询订单总和
 */
const orderCount = (params = {}) => get("/ovopark-console/module/orderCount", params);
/**
 * 查询字典表
 */
const getDictTree = (params = {}) => get('/ovopark-console/dict/dictTree', params);
/**
 * 保存发票
 */
const saveTicket = (params = {}) => postJson('/ovopark-console/bill/save', params);
/**
 * 省市区地址
 */
const getXzqhTree = (params = {}) => post('/analy/getXzqhTree.action', params);

export default {
  setToken,
  setEnvironMent,
  getOrganizesTree,
  getPrivileges,
  getAllEnterprises,
  getMyInfo,
  getAccount,
  getModuleList,
  getModuleProductList,
  openModuleOrder,
  ordersModuleOrder,
  payByPublic,
  getPayRecords,
  saveInvoiceOfCrm,
  renewOrder,
  getModuleProductDetail,
  getStoreOrService,
  getMessageList,
  updateMessage,
  updateRenewType,
  getBillList,
  getUrgentList,
  getOrderOpens,
  usedRenew,
  getStore,
  getDevice,
  useProduct,
  wxPay,
  payDetail,
  orderCount,
  getDictTree,
  saveTicket,
  getXzqhTree
};
